// ============================================================
// @munawb/types — Enums
// مشتقة مباشرة من PostgreSQL ENUM types في قاعدة البيانات
// ============================================================

export type UserRole =
  | 'Employee'
  | 'Supervisor'
  | 'HeadOfDept'
  | 'DutyManager'
  | 'QualitySuper'
  | 'Manager'
  | 'Executive'
  | 'Admin';

export type ProfileStatus = 'active' | 'pending' | 'suspended' | 'rejected';

export type RiskLevel = 'منخفض' | 'متوسط' | 'عالي' | 'مرتفع' | 'حرج';

export type ShiftPeriod = 'صباحية' | 'مسائية' | 'ليلية';

export type EscalationTarget =
  | 'duty_manager'
  | 'medical_director'
  | 'executive_director';

export type NotificationType =
  | 'info'
  | 'updated'
  | 'escalation'
  | 'directed'
  | 'escalated'
  | 'system';

export type ComplaintType = 'خطية' | 'حضورية' | '937';

export type IncidentStatus =
  | 'مفتوح'
  | 'مصعد'
  | 'موجه'
  | 'طلب RCA'
  | 'مغلق'
  | 'RCA Completed';

export type DutyShiftStatus =
  | 'active'
  | 'ended'
  | 'report_pending'
  | 'closed';

export type ComplaintStatus = 'مفتوح' | 'مغلق' | 'محوّل';

export type CallRequestStatus = 'pending' | 'acknowledged' | 'resolved';

// ترجمة الأدوار للعرض
export const ROLE_LABELS: Record<UserRole, string> = {
  Employee:     'موظف',
  Supervisor:   'مشرف',
  HeadOfDept:   'رئيس قسم',
  DutyManager:  'مدير مناوب',
  QualitySuper: 'مشرف جودة',
  Manager:      'مدير طبي',
  Executive:    'مدير تنفيذي',
  Admin:        'مدير النظام',
};

// الأدوار التي تصل لصفحة supervisor.html
export const SUPERVISOR_ROLES: UserRole[] = [
  'Supervisor',
  'HeadOfDept',
  'DutyManager',
  'Manager',
];

// الأدوار التي تعتبر "إدارة عليا"
export const MANAGEMENT_ROLES: UserRole[] = [
  'DutyManager',
  'Manager',
  'Executive',
  'Admin',
];

// مصفوفة كاملة لكل أدوار النظام (مفيدة للقوائم المنسدلة)
export const USER_ROLE_VALUES: UserRole[] = [
  'Employee',
  'Supervisor',
  'HeadOfDept',
  'DutyManager',
  'QualitySuper',
  'Manager',
  'Executive',
  'Admin',
];
